import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';
import { getInlineScriptData } from '../../utils/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	{ query, route, match }: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
) => {
	const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
	const { name = '' } = route || {}; // Route can be null according to RouterContext

	let returnDefaultBoard = 'false';

	if (boardId === null) {
		returnDefaultBoard = 'true';
	}

	const { baseUrl } = tenantContext;

	const endpoint = `${baseUrl}/rest/greenhopper/1.0/xboard/config.json?returnDefaultBoard=${returnDefaultBoard}&rapidViewId=${boardId}&_=${Date.now()}&operation=ConfigJson`;

	try {
		const pendingData = getInlineScriptData('SPA_RAPIDBOARD_CONFIG') || fetchJson(endpoint);
		const data = await pendingData;
		return { data, boardId, route: name };
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.classic-projects.board-config.getData',
				message: 'An error was thrown while prefetching board config',
				name: 'ResourceError',
			},
			error,
		);
	}
};
